import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from '@mui/system';
import { useOffreService } from '@europrocurement/l2d-domain';
import { enqueueSnackbar } from 'notistack';
import { useParcoursFormalite } from '../provider/useParcoursFormalite';
import { parcoursFormalitePathResolver } from '../parcoursFormalitePathResolver';
import { SelectionFormality } from '../components';
import { useDomaine, useOrigine } from '../hooks';

const StepSelectionFormalites: React.FunctionComponent = function () {
    const { catalogsApi } = useOffreService();
    const {
        prescripteurId,
        setIdFormalites,
        containerWidth,
        setCurrentCatalog,
        setLoading,
        currentCatalogs,
        setCurrentCatalogs,
    } = useParcoursFormalite();
    const navigate = useNavigate();
    const domaineId = useDomaine();
    const origineId = useOrigine();

    React.useEffect(() => {
        setLoading(false);
    }, [setLoading]);

    if (!prescripteurId) {
        enqueueSnackbar('missing prescripteur', { variant: 'error' });
        throw new Error('missing prescripteur');
    }

    return (
        <Container maxWidth={containerWidth}>
            <SelectionFormality
                prescripteurId={prescripteurId}
                origine={origineId}
                domaine={domaineId}
                defaultGroups={
                    (currentCatalogs || []).length > 0
                        ? (currentCatalogs || [])
                              ?.filter((catalog) => catalog?.groupement !== undefined)
                              .map((catalog) => catalog?.groupement?.id as number)
                        : []
                }
                defaultCatalogs={
                    (currentCatalogs || []).length > 0
                        ? (currentCatalogs || [])?.map((catalog) => catalog.id as number)
                        : []
                }
                onChange={async (catalogs) => {
                    setLoading(true);
                    if (catalogs.length > 0) {
                        const catalogRes = await catalogsApi.apiCataloguesIdGet({
                            id: `${catalogs[0].id}`,
                        });
                        setCurrentCatalog(catalogRes.data);
                        setCurrentCatalogs(catalogs);
                    }
                    setIdFormalites(
                        catalogs.map((catalog) => {
                            if (!catalog.package?.formalite) {
                                throw new Error('catalog not linked to formalite');
                            }
                            if (!catalog.package?.formalite?.id) {
                                throw new Error('formalite id is not defined');
                            }
                            return catalog.package.formalite.id;
                        }),
                    );
                    navigate(parcoursFormalitePathResolver('stepClient'));
                }}
            />
        </Container>
    );
};

export default StepSelectionFormalites;
